<template>
    <div class="right-content">
        <div class="right-content-body">
            <div class="title">
                倡议书
            </div>
            <div class="content">
                <p class="indent">古往今来，地球妈妈用甘甜的乳汁哺育了无数代子孙。原来的她被小辈们装饰得楚楚动人。可是，现在人类为了自身的利益，将她折磨得天昏地暗。人类只有一个地球；而地球正面临着严峻的环境危机。“救救地球”已成为世界各国人民最强烈的呼声。 </p>
                <p class="indent">我为周围环境的恶化而感到心痛，我想：作为未来接班人的青少年，如果不了解人类环境的构成和环境问题的严重性，无视有关环境保护的法律法规，不去增强环境保护意识，自觉履行保护环境的义务的话，我们的生命将毁在自己的手中，老天将对我们作出严厉的惩罚。为此我下定决心要从我做起爱护环境，保护我们这个赖以生存的家园，做一个保护环境的卫士。 </p>
                <p class="indent">在刚过去的一年中，我积极参加学校开展的植树活动，带领我们初一(6)中队的班干部创立了“绿色天使”植绿护绿小组，鼓励队员们在校园里认养了一棵小树苗，利用课余时间给它梳妆打扮，为它长成参天大树打下了基础。在学校组织的“让地球充满生机”的签字活动中，我郑重地在上面签下自己的名字，并写下了自己对环保的决心和期望，对美好未来的憧憬。我积极参加学校在世界环境日举行的有奖征稿，认真查阅、收集各类资料，进行社会调查，撰写有关环境治理设想方面的文章，我经常去参加学校组织的环保讲座，观看环保方面的录相带，积极参预环保知识问答调查活动，认真填写每一项提问。我参与了“红领巾植绿护绿队”的网站建设，在上面发布大量的环保图片和环保知识，以及关于环保的各方面的法律知识，我国在环保方面发展动向、世界各国的环境保护情况；每个月我都利用网络、报纸，查找一些最新的不同的专题和板块“环保资讯”来告诉大家；还定期制作一些宣传板来宣传环保知识和生活中的环保常识。提高了大家的环保意识；号召同学们从不同的方面来关爱自己的家园，从身边的小事做起，为周围的环境奉献自己的一份力量!我积极动员身边的人一起来依法保护和建设人类共有的同样也是仅有的家园，为促进经济和社会的可持续发展，为人类的文明做出贡献。我还和同学们共同发起“养一盆花，认养一棵树、爱惜每一片绿地，让我们周围充满绿色”和“小用塑料袋不使用泡沫饭盒和一次性筷子，让我们远离白色污染”的倡议。让我们放下方便袋，拿起菜篮子，让我们共同走向美好的绿色的明天，走向辉煌、灿烂的未来! </p>
                <p class="indent">据我收集到的一份报告说：“环境问题是由于人类不合理地开发和利用自然源所造成的。触目惊心的环境问题主要有大气污染、水质污染、噪声污染、食品污染、不适当开发利用自然资源这五大类。”一个个铁一样的事实告诉我们，它们像恶魔般无情地吞噬着人类的生命。它威胁着生态平衡，危害着人体健康，制约着经济和社会的可持续发展，它让人类陷入了困境。为此我作出宣告：“只要我们——人类有时刻不忘保护环境的意识，有依法治理环境的意识，地球村将成为美好的乐园”。未来的天空一定是碧蓝的，水是清澈的，绿树成荫鲜花遍地，人类可以尽情享受大自然赋予我们的幸福。 </p>
                <p class="indent">“真正检验我们对环境的贡献不是言辞，而是行动。”虽然我现在做得只不过是一些微小的事，但是我坚信要是我们人人都有保护环境的责任心，从自己做起，从小事做起，携手保护我们的家园，自然会给人类应有的回报。在温暖的摇篮——草原上小憩；在慈祥的笑脸——天空下成长，在爱的源泉——河流中沐浴。 </p>
            </div>

        </div>
    </div>
</template>

<script>
    export default {
        name: "InitiativeView"
    }
</script>

<style lang="scss" scoped>
    .right-content {
        padding: 30px;
        margin-left: 130px;
        font-size: 13px;
        .right-content-body {
            max-height: 620px;
            overflow-y: auto;
            overflow-x: hidden;
            .title {
                -webkit-text-stroke: 0.05em #33c;
                -webkit-text-fill-color : transparent;
                font-size: 30px;
                text-shadow: 3px 3px 2px #b2b2b2;
                text-align: left;
                font-family: SimSun;
            }
        }
    }
</style>